/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProfileNotificationsPage_viewer$ref = any;
export type ProfileNotificationsPage_QueryVariables = {||};
export type ProfileNotificationsPage_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: ProfileNotificationsPage_viewer$ref,
  |}
|};
export type ProfileNotificationsPage_Query = {|
  variables: ProfileNotificationsPage_QueryVariables,
  response: ProfileNotificationsPage_QueryResponse,
|};
*/


/*
query ProfileNotificationsPage_Query {
  viewer {
    actualPersonId
    component(name: "profile-notifications-page")
    ...ProfileNotificationsPage_viewer
    id
  }
}

fragment DeprecatedProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment ProfileNotificationsPage_viewer on Viewer {
  projectOwner
  disableNotifications
  company {
    forecastDemo
    tier
    id
  }
  ...profileNotificationsSettings_viewer
  ...ProfileProjectStatusUpdates_viewer
  ...SettingsProfileSubNav_viewer
}

fragment ProfileProjectStatusUpdates_viewer on Viewer {
  id
  email
  personDismissedProjectNotificationIds
  personNotificationSettings {
    id
    projectStatusEmailEnabled
    projectStatusEmailDay
    projectStatusEmailHour
  }
  projects(first: 100000, excludeDoneOrHalted: true) {
    edges {
      ...ProjectDropdown_projects
      node {
        id
        name
        companyProjectId
        projectColor
        userIsProjectOwner
      }
    }
  }
}

fragment ProjectDropdown_projects on ProjectTypeEdge {
  node {
    id
    name
    projectColor
    companyProjectId
    customProjectId
    status
    ...DeprecatedProjectIndicatorJS_project
    manualProgressOnProjectEnabled
    manualProgressOnPhasesEnabled
    manualProgressOnTasksEnabled
  }
}

fragment SettingsProfileSubNav_viewer on Viewer {
  id
  projectOwner
  disableNotifications
  company {
    id
    forecastDemo
    tier
  }
}

fragment profileNotificationsSettings_viewer on Viewer {
  id
  slackId
  availableFeatureFlags {
    key
    id
  }
  company {
    teamsEnabled
    newSlackEnabled
    useTimeOffApproval
    id
  }
  actualPersonId
  notificationFrequency
  notifyOnProjectStatusChange
  notifyOnAssignedProject
  notifyOnPersonJoin
  notifyOnProjectDeadline
  notifyOnAssignedTask
  notifyOnAssignedTaskUpdate
  notifyOnTaskDeadline
  notifyOnMention
  disableNotifications
  projectDeadlineNotificationPeriod
  taskDeadlineNotificationPeriod
  invoiceNotificationDaysOverdue
  notifyOnTaskDescriptionChange
  notifyOnTaskTitleChange
  notifyOnTaskEstimateChange
  notifyOnTaskStartDateChange
  notifyOnTaskEndDateChange
  notifyOnTaskSprintChange
  notifyOnTaskPhaseChange
  notifyOnTaskStatusColumnChange
  notifyOnTaskProjectChange
  notifyOnTaskSubtaskChange
  notifyOnTaskSubtaskEstimateChange
  notifyOnTaskCommentChange
  notifyOnTaskFileChange
  notifyOnTaskBugChange
  notifyOnTaskBlockedChange
  notifyOnTaskRepeatingChange
  notifyOnInvoiceDueDate
  notifyOnInvoiceOverdue
  notifyOnInvoiceDaysOverdue
  notifyOnInvoiceCreatedOrDeleted
  notifyOnInvoiceStatusChange
  notifyOnInvoiceDateReached
  notifyOnInvoicePayment
  notifyOnInvoiceDateChanged
  notifyOnInvoiceDueDateChanged
  notifyOnTimeOffManager
  notifyOnTimeOffOwner
  notifyInAppOnProjectStatusChange
  notifyInAppOnAssignedProject
  notifyInAppOnPersonJoin
  notifyInAppOnProjectDeadline
  notifyInAppOnAssignedTask
  notifyInAppOnAssignedTaskUpdate
  notifyInAppOnTaskDeadline
  notifyInAppOnMention
  disableInAppNotifications
  notifyInAppOnTaskDescriptionChange
  notifyInAppOnTaskTitleChange
  notifyInAppOnTaskEstimateChange
  notifyInAppOnTaskStartDateChange
  notifyInAppOnTaskEndDateChange
  notifyInAppOnTaskSprintChange
  notifyInAppOnTaskPhaseChange
  notifyInAppOnTaskStatusColumnChange
  notifyInAppOnTaskProjectChange
  notifyInAppOnTaskSubtaskChange
  notifyInAppOnTaskSubtaskEstimateChange
  notifyInAppOnTaskCommentChange
  notifyInAppOnTaskFileChange
  notifyInAppOnTaskBugChange
  notifyInAppOnTaskBlockedChange
  notifyInAppOnTaskRepeatingChange
  notifyInAppOnInvoiceDueDate
  notifyInAppOnInvoiceOverdue
  notifyInAppOnInvoiceDaysOverdue
  notifyInAppOnInvoiceCreatedOrDeleted
  notifyInAppOnInvoiceStatusChange
  notifyInAppOnInvoiceDateReached
  notifyInAppOnInvoicePayment
  notifyInAppOnInvoiceDateChanged
  notifyInAppOnInvoiceDueDateChanged
  notifyInAppOnTimeOffManager
  notifyInAppOnTimeOffOwner
  personNotificationSettings {
    id
    projectDeadlineOnlyAssignedProjects
    stateChangedOnlyAssignedProjects
    invoiceDueDateOnlyOwned
    invoiceOverdueOnlyOwned
    invoiceDaysOverdueOnlyOwned
    invoiceCreatedOrDeletedOnlyOwned
    invoiceStatusChangeOnlyOwned
    invoiceDateReachedOnlyOwned
    invoicePaymentOnlyOwned
    invoiceDateChangedOnlyOwned
    invoiceDueDateChangedOnlyOwned
  }
  teamsNotificationSettings {
    disableNotifications
    notifyOnProjectStatusChange
    notifyOnAssignedProject
    notifyOnPersonJoin
    notifyOnProjectDeadline
    notifyOnAssignedTask
    notifyOnAssignedTaskUpdate
    notifyOnTaskDeadline
    notifyOnMention
    notifyOnTaskDescriptionChange
    notifyOnTaskTitleChange
    notifyOnTaskEstimateChange
    notifyOnTaskStartDateChange
    notifyOnTaskEndDateChange
    notifyOnTaskSprintChange
    notifyOnTaskPhaseChange
    notifyOnTaskStatusColumnChange
    notifyOnTaskProjectChange
    notifyOnTaskSubtaskChange
    notifyOnTaskSubtaskEstimateChange
    notifyOnTaskCommentChange
    notifyOnTaskFileChange
    notifyOnTaskBugChange
    notifyOnTaskBlockedChange
    notifyOnTaskRepeatingChange
    notifyOnInvoiceDueDate
    notifyOnInvoiceOverdue
    notifyOnInvoiceDaysOverdue
    notifyOnInvoiceCreatedOrDeleted
    notifyOnInvoiceStatusChange
    notifyOnInvoiceDateReached
    notifyOnInvoicePayment
    notifyOnInvoiceDateChanged
    notifyOnInvoiceDueDateChanged
    notifyOnTimeOffManager
    notifyOnTimeOffOwner
  }
  slackNotificationSettings {
    disableNotifications
    notifyOnProjectStatusChange
    notifyOnAssignedProject
    notifyOnPersonJoin
    notifyOnProjectDeadline
    notifyOnAssignedTask
    notifyOnAssignedTaskUpdate
    notifyOnTaskDeadline
    notifyOnMention
    notifyOnTaskDescriptionChange
    notifyOnTaskTitleChange
    notifyOnTaskEstimateChange
    notifyOnTaskStartDateChange
    notifyOnTaskEndDateChange
    notifyOnTaskSprintChange
    notifyOnTaskPhaseChange
    notifyOnTaskStatusColumnChange
    notifyOnTaskProjectChange
    notifyOnTaskSubtaskChange
    notifyOnTaskSubtaskEstimateChange
    notifyOnTaskCommentChange
    notifyOnTaskFileChange
    notifyOnTaskBugChange
    notifyOnTaskBlockedChange
    notifyOnTaskRepeatingChange
    notifyOnInvoiceDueDate
    notifyOnInvoiceOverdue
    notifyOnInvoiceDaysOverdue
    notifyOnInvoiceCreatedOrDeleted
    notifyOnInvoiceStatusChange
    notifyOnInvoiceDateReached
    notifyOnInvoicePayment
    notifyOnInvoiceDateChanged
    notifyOnInvoiceDueDateChanged
    notifyOnTimeOffManager
    notifyOnTimeOffOwner
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "profile-notifications-page"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"profile-notifications-page\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableNotifications",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectStatusChange",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedProject",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnPersonJoin",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectDeadline",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTask",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTaskUpdate",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDeadline",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnMention",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDescriptionChange",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskTitleChange",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEstimateChange",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStartDateChange",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEndDateChange",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSprintChange",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskPhaseChange",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStatusColumnChange",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskProjectChange",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskChange",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskEstimateChange",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskCommentChange",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskFileChange",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBugChange",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBlockedChange",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskRepeatingChange",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDueDate",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceOverdue",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDaysOverdue",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceCreatedOrDeleted",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceStatusChange",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDateReached",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoicePayment",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDateChanged",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDueDateChanged",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTimeOffManager",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTimeOffOwner",
  "storageKey": null
},
v39 = [
  (v2/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v25/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/),
  (v38/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileNotificationsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileNotificationsPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ProfileNotificationsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectOwner",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "forecastDemo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tier",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "teamsEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newSlackEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useTimeOffApproval",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slackId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeatureFlag",
            "kind": "LinkedField",
            "name": "availableFeatureFlags",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notificationFrequency",
            "storageKey": null
          },
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "projectDeadlineNotificationPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskDeadlineNotificationPeriod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceNotificationDaysOverdue",
            "storageKey": null
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnProjectStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnAssignedProject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnPersonJoin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnProjectDeadline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnAssignedTask",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnAssignedTaskUpdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskDeadline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnMention",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disableInAppNotifications",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskDescriptionChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskTitleChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskEstimateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskStartDateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskEndDateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskSprintChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskPhaseChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskStatusColumnChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskProjectChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskSubtaskChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskSubtaskEstimateChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskCommentChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskFileChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskBugChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskBlockedChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTaskRepeatingChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceOverdue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDaysOverdue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceCreatedOrDeleted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDateReached",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoicePayment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDateChanged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnInvoiceDueDateChanged",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTimeOffManager",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notifyInAppOnTimeOffOwner",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PersonNotificationSettingsType",
            "kind": "LinkedField",
            "name": "personNotificationSettings",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectDeadlineOnlyAssignedProjects",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stateChangedOnlyAssignedProjects",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDueDateOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceOverdueOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDaysOverdueOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceCreatedOrDeletedOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceStatusChangeOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDateReachedOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoicePaymentOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDateChangedOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "invoiceDueDateChangedOnlyOwned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStatusEmailEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStatusEmailDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStatusEmailHour",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationSettingsType",
            "kind": "LinkedField",
            "name": "teamsNotificationSettings",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationSettingsType",
            "kind": "LinkedField",
            "name": "slackNotificationSettings",
            "plural": false,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personDismissedProjectNotificationIds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "excludeDoneOrHalted",
                "value": true
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 100000
              }
            ],
            "concreteType": "ProjectTypeConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "companyProjectId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customProjectId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manualProgressOnProjectEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manualProgressOnPhasesEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "manualProgressOnTasksEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userIsProjectOwner",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projects(excludeDoneOrHalted:true,first:100000)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ProfileNotificationsPage_Query",
    "operationKind": "query",
    "text": "query ProfileNotificationsPage_Query {\n  viewer {\n    actualPersonId\n    component(name: \"profile-notifications-page\")\n    ...ProfileNotificationsPage_viewer\n    id\n  }\n}\n\nfragment DeprecatedProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment ProfileNotificationsPage_viewer on Viewer {\n  projectOwner\n  disableNotifications\n  company {\n    forecastDemo\n    tier\n    id\n  }\n  ...profileNotificationsSettings_viewer\n  ...ProfileProjectStatusUpdates_viewer\n  ...SettingsProfileSubNav_viewer\n}\n\nfragment ProfileProjectStatusUpdates_viewer on Viewer {\n  id\n  email\n  personDismissedProjectNotificationIds\n  personNotificationSettings {\n    id\n    projectStatusEmailEnabled\n    projectStatusEmailDay\n    projectStatusEmailHour\n  }\n  projects(first: 100000, excludeDoneOrHalted: true) {\n    edges {\n      ...ProjectDropdown_projects\n      node {\n        id\n        name\n        companyProjectId\n        projectColor\n        userIsProjectOwner\n      }\n    }\n  }\n}\n\nfragment ProjectDropdown_projects on ProjectTypeEdge {\n  node {\n    id\n    name\n    projectColor\n    companyProjectId\n    customProjectId\n    status\n    ...DeprecatedProjectIndicatorJS_project\n    manualProgressOnProjectEnabled\n    manualProgressOnPhasesEnabled\n    manualProgressOnTasksEnabled\n  }\n}\n\nfragment SettingsProfileSubNav_viewer on Viewer {\n  id\n  projectOwner\n  disableNotifications\n  company {\n    id\n    forecastDemo\n    tier\n  }\n}\n\nfragment profileNotificationsSettings_viewer on Viewer {\n  id\n  slackId\n  availableFeatureFlags {\n    key\n    id\n  }\n  company {\n    teamsEnabled\n    newSlackEnabled\n    useTimeOffApproval\n    id\n  }\n  actualPersonId\n  notificationFrequency\n  notifyOnProjectStatusChange\n  notifyOnAssignedProject\n  notifyOnPersonJoin\n  notifyOnProjectDeadline\n  notifyOnAssignedTask\n  notifyOnAssignedTaskUpdate\n  notifyOnTaskDeadline\n  notifyOnMention\n  disableNotifications\n  projectDeadlineNotificationPeriod\n  taskDeadlineNotificationPeriod\n  invoiceNotificationDaysOverdue\n  notifyOnTaskDescriptionChange\n  notifyOnTaskTitleChange\n  notifyOnTaskEstimateChange\n  notifyOnTaskStartDateChange\n  notifyOnTaskEndDateChange\n  notifyOnTaskSprintChange\n  notifyOnTaskPhaseChange\n  notifyOnTaskStatusColumnChange\n  notifyOnTaskProjectChange\n  notifyOnTaskSubtaskChange\n  notifyOnTaskSubtaskEstimateChange\n  notifyOnTaskCommentChange\n  notifyOnTaskFileChange\n  notifyOnTaskBugChange\n  notifyOnTaskBlockedChange\n  notifyOnTaskRepeatingChange\n  notifyOnInvoiceDueDate\n  notifyOnInvoiceOverdue\n  notifyOnInvoiceDaysOverdue\n  notifyOnInvoiceCreatedOrDeleted\n  notifyOnInvoiceStatusChange\n  notifyOnInvoiceDateReached\n  notifyOnInvoicePayment\n  notifyOnInvoiceDateChanged\n  notifyOnInvoiceDueDateChanged\n  notifyOnTimeOffManager\n  notifyOnTimeOffOwner\n  notifyInAppOnProjectStatusChange\n  notifyInAppOnAssignedProject\n  notifyInAppOnPersonJoin\n  notifyInAppOnProjectDeadline\n  notifyInAppOnAssignedTask\n  notifyInAppOnAssignedTaskUpdate\n  notifyInAppOnTaskDeadline\n  notifyInAppOnMention\n  disableInAppNotifications\n  notifyInAppOnTaskDescriptionChange\n  notifyInAppOnTaskTitleChange\n  notifyInAppOnTaskEstimateChange\n  notifyInAppOnTaskStartDateChange\n  notifyInAppOnTaskEndDateChange\n  notifyInAppOnTaskSprintChange\n  notifyInAppOnTaskPhaseChange\n  notifyInAppOnTaskStatusColumnChange\n  notifyInAppOnTaskProjectChange\n  notifyInAppOnTaskSubtaskChange\n  notifyInAppOnTaskSubtaskEstimateChange\n  notifyInAppOnTaskCommentChange\n  notifyInAppOnTaskFileChange\n  notifyInAppOnTaskBugChange\n  notifyInAppOnTaskBlockedChange\n  notifyInAppOnTaskRepeatingChange\n  notifyInAppOnInvoiceDueDate\n  notifyInAppOnInvoiceOverdue\n  notifyInAppOnInvoiceDaysOverdue\n  notifyInAppOnInvoiceCreatedOrDeleted\n  notifyInAppOnInvoiceStatusChange\n  notifyInAppOnInvoiceDateReached\n  notifyInAppOnInvoicePayment\n  notifyInAppOnInvoiceDateChanged\n  notifyInAppOnInvoiceDueDateChanged\n  notifyInAppOnTimeOffManager\n  notifyInAppOnTimeOffOwner\n  personNotificationSettings {\n    id\n    projectDeadlineOnlyAssignedProjects\n    stateChangedOnlyAssignedProjects\n    invoiceDueDateOnlyOwned\n    invoiceOverdueOnlyOwned\n    invoiceDaysOverdueOnlyOwned\n    invoiceCreatedOrDeletedOnlyOwned\n    invoiceStatusChangeOnlyOwned\n    invoiceDateReachedOnlyOwned\n    invoicePaymentOnlyOwned\n    invoiceDateChangedOnlyOwned\n    invoiceDueDateChangedOnlyOwned\n  }\n  teamsNotificationSettings {\n    disableNotifications\n    notifyOnProjectStatusChange\n    notifyOnAssignedProject\n    notifyOnPersonJoin\n    notifyOnProjectDeadline\n    notifyOnAssignedTask\n    notifyOnAssignedTaskUpdate\n    notifyOnTaskDeadline\n    notifyOnMention\n    notifyOnTaskDescriptionChange\n    notifyOnTaskTitleChange\n    notifyOnTaskEstimateChange\n    notifyOnTaskStartDateChange\n    notifyOnTaskEndDateChange\n    notifyOnTaskSprintChange\n    notifyOnTaskPhaseChange\n    notifyOnTaskStatusColumnChange\n    notifyOnTaskProjectChange\n    notifyOnTaskSubtaskChange\n    notifyOnTaskSubtaskEstimateChange\n    notifyOnTaskCommentChange\n    notifyOnTaskFileChange\n    notifyOnTaskBugChange\n    notifyOnTaskBlockedChange\n    notifyOnTaskRepeatingChange\n    notifyOnInvoiceDueDate\n    notifyOnInvoiceOverdue\n    notifyOnInvoiceDaysOverdue\n    notifyOnInvoiceCreatedOrDeleted\n    notifyOnInvoiceStatusChange\n    notifyOnInvoiceDateReached\n    notifyOnInvoicePayment\n    notifyOnInvoiceDateChanged\n    notifyOnInvoiceDueDateChanged\n    notifyOnTimeOffManager\n    notifyOnTimeOffOwner\n  }\n  slackNotificationSettings {\n    disableNotifications\n    notifyOnProjectStatusChange\n    notifyOnAssignedProject\n    notifyOnPersonJoin\n    notifyOnProjectDeadline\n    notifyOnAssignedTask\n    notifyOnAssignedTaskUpdate\n    notifyOnTaskDeadline\n    notifyOnMention\n    notifyOnTaskDescriptionChange\n    notifyOnTaskTitleChange\n    notifyOnTaskEstimateChange\n    notifyOnTaskStartDateChange\n    notifyOnTaskEndDateChange\n    notifyOnTaskSprintChange\n    notifyOnTaskPhaseChange\n    notifyOnTaskStatusColumnChange\n    notifyOnTaskProjectChange\n    notifyOnTaskSubtaskChange\n    notifyOnTaskSubtaskEstimateChange\n    notifyOnTaskCommentChange\n    notifyOnTaskFileChange\n    notifyOnTaskBugChange\n    notifyOnTaskBlockedChange\n    notifyOnTaskRepeatingChange\n    notifyOnInvoiceDueDate\n    notifyOnInvoiceOverdue\n    notifyOnInvoiceDaysOverdue\n    notifyOnInvoiceCreatedOrDeleted\n    notifyOnInvoiceStatusChange\n    notifyOnInvoiceDateReached\n    notifyOnInvoicePayment\n    notifyOnInvoiceDateChanged\n    notifyOnInvoiceDueDateChanged\n    notifyOnTimeOffManager\n    notifyOnTimeOffOwner\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '361aa89f85ef9941f3432ae5be712f85';

module.exports = node;
